var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_vm._t("sidebar"),_c('div',{staticClass:"page__main"},[_vm._t("topbar"),_vm._t("contentbar"),_c('div',{staticClass:"page__content"},[_vm._t("default")],2)],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }